import { GET_SLOT } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_SLOT:
            return action.payload;
        default:
            return state;
    }
}